export default async function (action, args) {
    console.log('cart-rule-action:add_coupon', { action, args })

    const store = window.addiesaas.store

    const code = action.code

    const discounts = Object.values(store.getters['Shop/Orders/Cart/cartDiscounts'])
    const couponDiscount = discounts.find(discount => discount.type == 'coupon' && discount.payload.options.code == code)

    if (!couponDiscount) {
        const discount = {
            title: code,
            type: 'coupon',
            payload: {
                type: 'coupon',
                options: {
                    code,
                },
            },
        }

        await store.dispatch('Shop/Orders/Cart/addDiscount', discount)

        window.addiesaas.$core.EventBus.$emit('cart.validate')
    }
}
